import './CircularPageLoader.css';

/**
 * Shared in-page indeterminate circular loader (no modal).
 * Used by activity registration, contact, career, and registration status flows.
 */
export default function CircularPageLoader({title, hint, ariaLabel}) {
    const label =
        ariaLabel ||
        (typeof title === 'string' && title ? title.replace(/\s*…\s*$/, '').trim() : 'Yükleniyor');

    return (
        <div
            className="circular-page-loader"
            role="status"
            aria-live="polite"
            aria-busy="true"
            aria-label={label}
        >
            <div className="circular-page-loader__spinner" aria-hidden="true">
                <svg viewBox="0 0 72 72" focusable="false">
                    <circle
                        className="circular-page-loader__track"
                        cx="36"
                        cy="36"
                        r="30"
                        fill="none"
                        strokeWidth="5"
                    />
                    <circle
                        className="circular-page-loader__arc"
                        cx="36"
                        cy="36"
                        r="30"
                        fill="none"
                        strokeWidth="5"
                        strokeLinecap="round"
                    />
                </svg>
            </div>
            {title ? <p className="circular-page-loader__title mb-1">{title}</p> : null}
            {hint ? <p className="circular-page-loader__hint mb-0">{hint}</p> : null}
        </div>
    );
}
